// exportApiCall.js
const exportApiCall = async (method, url, options = {}) => {
  try {
    const token = localStorage.getItem("authToken");

    const headers = {
      "Content-Type": "application/json",
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const fetchOptions = {
      method: method.toUpperCase(),
      headers,
      body: options.data ? JSON.stringify(options.data) : undefined,
    };

    const apiBase = `${process.env.REACT_APP_API_URL}`;
    if (!apiBase) {
      throw new Error("REACT_APP_API_URL is not defined");
    }

    const response = await fetch(`${apiBase}${url}`, fetchOptions);

    if (!response.ok) {
      const errorBody = await response.text();
      console.error("API Error Response:", errorBody);
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return options.responseType === "blob"
      ? await response.blob()
      : await response.json();
  } catch (error) {
    console.error("API Call Failed:", error);
    throw error;
  }
};

export default exportApiCall;
